module.exports = __webpack_public_path__ + "img/coronavirus.cbb8f42a.png";